(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * @type {{name: string, coordinates: { lat: float, lng: float }}|null}
         */
        var tourHotel = window.tourHotel || null;
        if (tourHotel !== null) {
            var hotelMapInitialize = function hotelMapInitialize() {
                var hotelCoords = { lat: tourHotel.coordinates.lat, lng: tourHotel.coordinates.lng };
                var hotelMap = new google.maps.Map(document.getElementById('tour-hotel-map'), {
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    zoom: 16,
                    scrollwheel: false,
                    center: hotelCoords
                });
                var marker = new google.maps.Marker({
                    position: hotelCoords,
                    map: hotelMap,
                    title: tourHotel.name
                });
            };

            $(document).ready(function () {
                document.querySelector('.hotel-map__load-map').addEventListener('click', function (e) {
                    e.currentTarget.parentNode.classList.remove('hotel-map__skeleton-bg');
                    e.currentTarget.remove();
                    if (typeof window.loadGoogleMapsApi === 'function') {
                        window.loadGoogleMapsApi(hotelMapInitialize);
                    }
                }, { once: true });
            });
        }
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $('.js-more-info').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.js-info').addClass('open');
        });

        $('.btn-more-reviews').on('click', function (e) {
            var $tab = $(this).closest('.reviews-content');
            if ($tab.length) {
                $tab.find('.hidden').removeClass('hidden');
            }

            $(this).remove();

            e.preventDefault();
        });

        function showFail() {
            var $element = $('.tour-request-popup .tour-info');
            if ($element.length === 0) {
                return;
            }
            $element.html("\n        <div class=\"alert alert-danger text-center\">\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A</div>  \n    ");
        }

        function showTourInfo(data) {
            var $element = $('.tour-request-popup .tour-info');
            if ($element.length === 0) {
                return;
            }
            var content = "\n        <div class=\"stars\">{{stars}}</div>\n        <div class=\"hotel-name\">{{hotelName}}</div>\n        <div class=\"hotel-place\">{{region}}, {{country}}</div>\n        <div class=\"tour-details-wrapper\">\n            <div class=\"tour-img\">\n                <img src=\"{{photo}}\" alt=\"\u0424\u043E\u0442\u043E \u043E\u0442\u0435\u043B\u044F\">\n            </div>\n            <div class=\"tour-details\">\n                <b>\u0414\u0435\u0442\u0430\u043B\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F:</b>\n                <div class=\"tour-columns\">\n                    <ul>\n                        <li><span>\u0412\u044B\u043B\u0435\u0442 \u0438\u0437: </span>{{departCity}}</li>\n                        <li><span>\u041D\u043E\u043C\u0435\u0440: </span>{{room}}</li>\n                        <li><span>\u041F\u0438\u0442\u0430\u043D\u0438\u0435: </span>{{meal}}</li>\n                    </ul>\n                    <ul>\n                        <li><span>\u0414\u0430\u0442\u044B \u0442\u0443\u0440\u0430: </span>{{dates}}</li>\n                        <li><span>\u041A\u0442\u043E \u0435\u0434\u0435\u0442: </span>{{peoples}}</li>\n                    </ul>\n                </div>\n                <div class=\"tour-price\">{{price}}{{currency}}</div>\n            </div>\n        </div>\n    ";
            content = content.split('{{hotelName}}').join(data.hotel);
            content = content.split('{{region}}').join(data.region);
            content = content.split('{{country}}').join(data.country);
            content = content.split('{{photo}}').join(data.photo);
            content = content.split('{{room}}').join(data.room);
            content = content.split('{{accommodation}}').join(data.accomodation);
            content = content.split('{{departCity}}').join(data.departCity);
            content = content.split('{{meal}}').join(data.meal);
            content = content.split('{{price}}').join(window.utils.nf(data.price));
            content = content.split('{{currency}}').join(data.currency);
            var dateFrom = moment(data.dateFrom, 'YYYY-MM-DD');
            var dateTo = moment(data.dateTo, 'YYYY-MM-DD');
            var nightsOnWay = '';
            if (data.nightsOnWay) {
                nightsOnWay = '+' + data.nightsOnWay + ' ' + window.utils.getnoun(data.nightsOnWay, 'ночь', 'ночи', 'ночей') + ' в пути';
            }

            var dates = dateFrom.format('D MMMM') + ' - ' + dateTo.format('D MMMM') + ' (' + data.days + ' ' + window.utils.getnoun(data.days, 'день', 'дня', 'дней') + nightsOnWay + ')';
            content = content.split('{{dates}}').join(dates);
            var stars = data.class;
            if (data.stars !== 0) {
                stars = '';
                for (var i = 1; i <= 5; i++) {
                    var gray = i > data.stars ? 'gray' : '';
                    stars += "<span class=\"star " + gray + "\"></span>";
                }
            }
            content = content.split('{{stars}}').join(stars);
            var peoplesText = data.adult + ' ' + (data.child > 0 ? 'взр. ' + data.child + ' реб.' : window.utils.getnoun(data.adult, 'взрослый', 'взрослых', 'взрослых'));
            content = content.split('{{peoples}}').join(peoplesText);
            $element.html(content);
        }

        $('body').on('click', '.open-tour-request', function (e) {
            e.preventDefault();
            var tourId = $(this).data('id');
            var currentCity = window.CityItem.getCurrent();
            var currentPhone = currentCity.getPhoneView();

            var $callbackFormContainer = $('.tour-detail-callback-container');
            var template = "\n        <div class=\"tour-request-popup\">\n            <div class=\"tour-info\">\n                Loader\n            </div>\n            <div class=\"tour-actual-info\">\n                \u0417\u0432\u043E\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C \u0432\u0441\u044E \u043F\u043E\u0434\u0431\u043E\u0440\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043F\u043E \u0442\u0443\u0440\u0443\n                <span id=\"popup-tour-id\">" + tourId + "</span><br>\n                <span class=\"current-phone site-phone\">" + currentPhone + "</span>\n            </div>\n            <div class=\"tour-advice\">\n                \u041A\u0441\u0442\u0430\u0442\u0438, \u043D\u0430\u0448 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442 \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0434\u043E\u0431\u0440\u0430\u0442\u044C \u0442\u0443\u0440 \u043F\u043E \u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435.\n            </div>\n            <div class=\"callback-request-form\">\n                <div class=\"block-title\">\u0418\u043B\u0438 \u0437\u0430\u043A\u0430\u0436\u0438\u0442\u0435 \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A \u0438 \u0432\u0430\u043C \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u044F\u0442 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F</div>\n                " + $callbackFormContainer.html() + "\n                <div class=\"block-hint\">\n                    * \u041C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C \u0432\u0430\u0448\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u0437\u0430\u043A\u0430\u0437\u0430 \u0438 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0432\u0430\u043C\u0438, \u0438 \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0435\u043C \n                    \u0438\u0445 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C.\n                </div>\n            </div>\n        </div>\n    ";
            bs3popup({
                width: 736,
                content: template,
                setLock: true
            });
            bs3popup('show');
            var selector = '#popup-tour-id';
            window.utils.getShortTourId($(selector).text(), selector);
            initPhoneMask();
            $.getJSON(window.app.urls.findTour + '?id=' + encodeURIComponent(tourId), function (data) {
                if (data.error) {
                    showFail();
                }
                showTourInfo(data);
            }).fail(function () {
                showFail();
            });
        });

        $(window).on('newSearchStart', function () {
            $('.hotel-min-price-wrapper').addClass('hidden');
        }).on('newTourMinPrice', function (e, data) {
            var $wrapper = $('.hotel-min-price-wrapper');
            $wrapper.removeClass('hidden');
            $wrapper.find('.hotel-min-price').html("\u043E\u0442 " + window.utils.nfm(data.tourMinPrice.value) + data.tourMinPrice.currency);
            $wrapper.find('.search-people-count').html(data.info);
        });
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var slideTimer = null;
        var itemMarginX = 4; // left/right, both itemMarginX
        var itemWidth = 125; // Ширина одной картинки (с бордером и маргином)
        var scrollStep = 4; // Скорость прокрутки

        var $mainImageContainer = $('#bigImg_wrap');
        var $mainImage = $('#bigImg');
        var $mainImageBg = $('.blur-bg');
        var $previewContainer = $('.hotel-pictures-slider');
        var $previewSlider = $('#previewImagesWrap');

        var previewViewportWidth = $previewContainer.width();
        var previewScrollWidth = $previewSlider.width();
        // Ширина preview картинки + marginX
        var itemOuterWidth = itemMarginX * 2 + itemWidth;
        // Количество полностью видимых картинок
        var itemsPerViewport = Math.floor(previewViewportWidth / itemOuterWidth);

        function slideToImage(current, max) {
            if (max <= itemsPerViewport) {
                // Все фото видимы во viewport
                return;
            }

            var maxOffsetLeft = previewScrollWidth - previewViewportWidth;
            // Позиция - максимально прижато к левому краю
            // let offsetLeft = itemOuterWidth * current;
            // Позиция - по центру
            var offsetLeft = itemOuterWidth * current - previewViewportWidth / 2 + itemOuterWidth / 2;
            if (offsetLeft > maxOffsetLeft) {
                offsetLeft = maxOffsetLeft;
            } else if (offsetLeft < 0) {
                offsetLeft = 0;
            }
            $previewSlider.animate({
                left: '-' + offsetLeft + 'px'
            }, 200);
        }

        function setCurrentImage($newPreviewImage) {
            $mainImage.attr('src', $newPreviewImage.data('big')).data('cur', $newPreviewImage.data('index'));
            $mainImageBg.css('background-image', 'url("' + $newPreviewImage.data('big') + '")');

            $previewSlider.find('.active').removeClass('active');
            $newPreviewImage.addClass('active');

            slideToImage($newPreviewImage.data('index'), $mainImage.data('max'));
        }

        function imagesMove(e) {
            clearTimeout(slideTimer);
            var imageOffset = $previewContainer.offset();
            // Координаты области на странице
            var previewViewBox = {
                leftX: imageOffset.left,
                rightX: imageOffset.left + previewViewportWidth
            };

            // Размер области от края, при которой срабатывает анимация
            var activeAreaWidth = 60;
            if (e.pageX > previewViewBox.leftX + activeAreaWidth && e.pageX < previewViewBox.rightX - activeAreaWidth) {
                // Скролл не срабатывает при наведении на центр слайдера, только на края
                return;
            }

            var sliderX = e.pageX - imageOffset.left;
            var direction = previewViewportWidth / 2 - sliderX;
            // Шаг в px, на сколько изменится позиция анимации
            var step = direction > 0 ? scrollStep : -scrollStep;

            var offsetLeft = parseFloat($previewSlider.css('left'));
            var maxOffsetLeft = previewScrollWidth - previewViewportWidth;
            var newX = offsetLeft + step;
            if (newX > 0) {
                newX = 0;
            } else if (newX < -maxOffsetLeft) {
                newX = -maxOffsetLeft;
            }
            if (newX === offsetLeft) {
                return;
            }

            $previewSlider.css('left', newX + 'px');
            slideTimer = setTimeout(function () {
                imagesMove(e);
            }, 40);
        }

        $(document).ready(function () {
            $('.bigImg_wrap_left, .bigImg_wrap_right', $mainImageContainer).on('click', function (e) {
                e.preventDefault();
                var data = $mainImage.data();
                var dir = $(this).hasClass('bigImg_wrap_left') ? -1 : 1;

                var newIndex = data.cur + dir;
                if (newIndex > data.max) {
                    newIndex = newIndex - data.max - 1;
                }
                if (newIndex < 0) {
                    newIndex = data.max;
                }

                var $newImagePreview = $("div:eq(" + newIndex + ")", $previewSlider);
                setCurrentImage($newImagePreview);
            });

            $previewContainer.on('mousemove', function (e) {
                imagesMove(e);
            }).on('mouseleave', function (e) {
                clearTimeout(slideTimer);
            }).on('keydown', function (e) {
                var key = e.which;
                switch (key) {
                    case 37:
                        $('.bigImg_wrap_left').trigger('click');
                        break;
                    case 39:
                        $('.bigImg_wrap_right').trigger('click');
                        break;
                }
            });

            $previewSlider.find('div')
            // on image preview click
            .on('click', function (e) {
                // Останавливаем анимацию по наведению
                clearTimeout(slideTimer);
                setCurrentImage($(this));
            });
        });
    }, {}] }, {}, [1]);